export default (value: string | number): number => {
  if (typeof value === 'string') {
    const stripValue: string = value.replace(/[^0-9.]/g, '')
    value = parseFloat(stripValue)
  }

  return value
}
